class QuickAdd extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {

      if (this.classList.contains('is-active')) {
        this.classList.remove('is-active');
        this.expand();

      } else {
        this.classList.add('is-active');
        let allPopUps = document.querySelectorAll('.quick-add-popup'),
            allAddToCart = document.querySelectorAll('.quick-add-to-cart');
        allPopUps.forEach(el => el.classList.remove('is-active'));
        allAddToCart.forEach(el => el.classList.remove('is-active'));
        this.classList.add('is-active');
        this.expand();
      }
      

      let testimonial__slider = document.querySelectorAll('.testimonial__slider');
      if(this.classList.contains('is-active')) {
        testimonial__slider.forEach(el => el.classList.add('is-active'));
      } else {
        testimonial__slider.forEach(el => el.classList.remove('is-active'));
      }


      let recommendedProductSlider = document.querySelectorAll('.recommended-products__slider');
      if(this.classList.contains('is-active')) {
        recommendedProductSlider.forEach(el => el.classList.add('is-active'));
      } else {
        recommendedProductSlider.forEach(el => el.classList.remove('is-active'));
      }
    });
  }
  expand() {
    let productHandle = this.getAttribute('data-product-url');
    let quickAddContainer = this.nextElementSibling

    fetch(`/products/${productHandle}?section_id=stmt-quick-add-product-card`)
    .then((product) => {
      return product.text();
    }).then((product) => {   
      
      quickAddContainer.innerHTML = ''      

      const parser = new DOMParser();
      const productHtml = parser.parseFromString(product, "text/html");
      const cardContent = productHtml.querySelector('.js-card');

      if (quickAddContainer) {
        quickAddContainer.innerHTML += cardContent.innerHTML
      }

    }).finally(() => {
      quickAddContainer.classList.toggle('is-active');
      document.dispatchEvent(new 
        CustomEvent("swym:loaded"));
    })

  }
}

customElements.define('quick-add-to-cart', QuickAdd);


class QuickAddForm extends HTMLElement {

  constructor(){
    super();
    this.form = this.querySelector('.js-quick-add-form');
    this.options = '';
    this.variantData = '';
    this.currentVariant = '';
    this.getVariantData();
    this.disableOptions();
    this.listeners();
  }

  listeners() {
    if (this.form) {    

      let cartPage = document.querySelectorAll('.cart-page-add');
      if (cartPage) {
        cartPage.forEach(popUp => {
          let popUpForm = popUp.querySelectorAll('.js-quick-add-form');
          popUpForm.forEach(el => el.classList.add('cart-pop-up-form'));
        });
      }

      if (!this.form.classList.contains('cart-pop-up-form')) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }

      this.form.addEventListener('change', (event) => {
        this.updateSelectedVariant(event);
      });
    }
  }

  addToCart() {
    const formData = new FormData(this.form);
    const max = 99;
    const sections = ['stmt-popout-cart-delivery-banner', 'stmt-popout-cart-items', 'stmt-popout-cart-footer'];

    document.dispatchEvent(
      new CustomEvent('cart:add', { 
        detail: {
          data: { formData: formData, max: max, sections: sections }
        }
      })
    )
  }

  updateSelectedVariant(event, variant) {
    if (variant) {
      this.currentVariant = variant;
    }

    if (event.target.id === 'Option1') {
      this.disableOptions();
    }

    if (!this.currentVariant) {
      this.variantNotFound();
    } else {
      this.updatePrice();
      this.updateVariantInput();
      this.updateAvailability();
    }
  }
  
  disableOptions() {
    const select2_options = Array.from(this.querySelectorAll('#Option2 option'), (select) => select);
  
    let availableOptions = []
    this.variantData.forEach((variant, i) => {
      if (variant.options[0] === this.querySelector('#Option1').value) {
        availableOptions.push(variant.options[1])
      }
    })
  
    let isOptionSelected = false;
    select2_options.forEach(opt => {
      if (!availableOptions.includes(opt.value)) {
        opt.setAttribute("disabled", "");
      } else {
        opt.removeAttribute("disabled");
        if (!isOptionSelected) {
          opt.selected = true;
          isOptionSelected = true;
        }
      }
    })

    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('.js-quick-add-variants').textContent);
    return this.variantData;
  }

  updatePrice() {
    const price = this.querySelector('.js-quick-add-price');
    if (!price) return;

    price.innerText = this.currentVariant.price;
  }

  updateVariantInput() {
    const input = this.form.querySelector('input[name="id"]');
    if (!input) return;

    input.value = this.currentVariant.id;
  }

  updateAvailability() {
    const available = this.currentVariant.available;
    const submit = this.querySelector('.js-quick-add-submit');
    if (!submit) return;

    if (available) {
      submit.removeAttribute('disabled');
    } else {
      submit.setAttribute('disabled', 'disabled');
    }
  }

  variantNotFound() {
    const submit = this.querySelector('.js-quick-add-submit');
    if (!submit) return;
    
    submit.setAttribute('disabled', 'disabled');
  }
}
customElements.define('quick-add-form', QuickAddForm);
